"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "roma": {
    "934029bd": [{
      "hkey": "2093d671",
      "slug": "castelluccia-santa-maria-di-galeria",
      "name": "Castelluccia, Santa Maria di Galeria",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "2405a57f",
      "slug": "cassia-san-godenzo-due-ponti-grottarossa-tomba-di-nerone",
      "name": "Cassia-San Godenzo, Due Ponti, Grottarossa, Tomba di Nerone",
      "primary": true,
      "skipSearch": false
    }],
    "2dbf626b": [{
      "hkey": "1d01e051",
      "slug": "flaminio-parioli",
      "name": "Flaminio, Parioli",
      "primary": true,
      "skipSearch": false
    }],
    "c0f7b747": [{
      "hkey": "2405a57f",
      "slug": "cassia-san-godenzo-due-ponti-grottarossa-tomba-di-nerone",
      "name": "Cassia-San Godenzo, Due Ponti, Grottarossa, Tomba di Nerone",
      "primary": true,
      "skipSearch": false
    }],
    "0d1ea32f": [{
      "hkey": "efd364d2",
      "slug": "castel-di-leva-fonte-laurentina-vallerano",
      "name": "Castel di Leva-Fonte Laurentina, Vallerano",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "f50be3f0",
      "slug": "castel-porziano-castel-romano-trigoria",
      "name": "Castel Porziano, Castel Romano, Trigoria",
      "primary": true,
      "skipSearch": false
    }],
    "dc313963": [{
      "hkey": "f9eea843",
      "slug": "primavalle-battistini-torrevecchia",
      "name": "Primavalle-Battistini, Torrevecchia",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "d337d956",
      "slug": "ottavia-monte-mario-trionfale",
      "name": "Ottavia, Monte Mario-Trionfale",
      "primary": true,
      "skipSearch": false
    }],
    "casilina-prenestina-centocelle-alessandrino": [{
      "hkey": "4214fc16",
      "slug": "alessandrino-casilina-centocelle",
      "name": "Alessandrino, Casilina, Centocelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "monteverde-gianicolense": [{
      "hkey": "73e873f6",
      "slug": "colli-portuensi-gianicolense-monteverde",
      "name": "Colli Portuensi, Gianicolense, Monteverde",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "2f9db33b": [{
      "hkey": "82a43961",
      "slug": "garbatella-ostiense-ardeatino",
      "name": "Garbatella, Ostiense, Ardeatino",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "180ecba5",
      "slug": "giuliano-dalmata-fonte-meravigliosa-laurentino",
      "name": "Giuliano Dalmata, Fonte Meravigliosa, Laurentino",
      "primary": true,
      "skipSearch": false
    }],
    "05a27222": [{
      "hkey": "a6eb7666",
      "slug": "cesano-giustiniana-olgiata",
      "name": "Cesano, Giustiniana, Olgiata",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "2093d671",
      "slug": "castelluccia-santa-maria-di-galeria",
      "name": "Castelluccia, Santa Maria di Galeria",
      "primary": false,
      "skipSearch": false
    }],
    "ad55a0be": [{
      "hkey": "94336790",
      "slug": "capannelle-cinecitta-quadraro",
      "name": "Capannelle, Cinecittà, Quadraro",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "7947a8ef",
      "slug": "appio-pignatelli-quarto-miglio",
      "name": "Appio Pignatelli, Quarto Miglio",
      "primary": false,
      "skipSearch": false
    }],
    "cf718db3": [{
      "hkey": "98460d55",
      "slug": "aurelio-val-cannuta",
      "name": "Aurelio-Val Cannuta",
      "primary": true,
      "skipSearch": false
    }],
    "valle-aurelia": [{
      "hkey": "98460d55",
      "slug": "aurelio-val-cannuta",
      "name": "Aurelio-Val Cannuta",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": "aurelio-val-cannuta-boccea"
    }],
    "b5a4037b": [{
      "hkey": "efd364d2",
      "slug": "castel-di-leva-fonte-laurentina-vallerano",
      "name": "Castel di Leva-Fonte Laurentina, Vallerano",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "f50be3f0",
      "slug": "castel-porziano-castel-romano-trigoria",
      "name": "Castel Porziano, Castel Romano, Trigoria",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "69c88fc3",
      "slug": "mezzocammino-spinaceto",
      "name": "Mezzocammino, Spinaceto",
      "primary": false,
      "skipSearch": false
    }],
    "6c997dcd": [{
      "hkey": "73e873f6",
      "slug": "colli-portuensi-gianicolense-monteverde",
      "name": "Colli Portuensi, Gianicolense, Monteverde",
      "primary": true,
      "skipSearch": false
    }],
    "8cd3b437": [{
      "hkey": "2093d671",
      "slug": "castelluccia-santa-maria-di-galeria",
      "name": "Castelluccia, Santa Maria di Galeria",
      "primary": true,
      "skipSearch": false
    }],
    "cassia-tomba-di-nerone": [{
      "hkey": "2405a57f",
      "slug": "cassia-san-godenzo-due-ponti-grottarossa-tomba-di-nerone",
      "name": "Cassia-San Godenzo, Due Ponti, Grottarossa, Tomba di Nerone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "appio-claudio-capannelle": [{
      "hkey": "94336790",
      "slug": "capannelle-cinecitta-quadraro",
      "name": "Capannelle, Cinecittà, Quadraro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "trigoria-castel-romano": [{
      "hkey": "f50be3f0",
      "slug": "castel-porziano-castel-romano-trigoria",
      "name": "Castel Porziano, Castel Romano, Trigoria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "b015a495": [{
      "hkey": "efd364d2",
      "slug": "castel-di-leva-fonte-laurentina-vallerano",
      "name": "Castel di Leva-Fonte Laurentina, Vallerano",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "46d6b680",
      "slug": "fioranello-aeroporto-ciampino",
      "name": "Fioranello-Aeroporto Ciampino",
      "primary": false,
      "skipSearch": false
    }],
    "castel-di-leva-vallerano": [{
      "hkey": "efd364d2",
      "slug": "castel-di-leva-fonte-laurentina-vallerano",
      "name": "Castel di Leva-Fonte Laurentina, Vallerano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "0a1b44f9": [{
      "hkey": "82a43961",
      "slug": "garbatella-ostiense-ardeatino",
      "name": "Garbatella, Ostiense, Ardeatino",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "937ded5a",
      "slug": "eur-tintoretto-torrino",
      "name": "Eur, Tintoretto, Torrino",
      "primary": true,
      "skipSearch": false
    }],
    "giustiniana-olgiata-cesano": [{
      "hkey": "a6eb7666",
      "slug": "cesano-giustiniana-olgiata",
      "name": "Cesano, Giustiniana, Olgiata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "8b443ad3": [{
      "hkey": "0a812f72",
      "slug": "farnesina-tor-di-quinto",
      "name": "Farnesina, Tor di Quinto",
      "primary": true,
      "skipSearch": false
    }],
    "47a2e4a6": [{
      "hkey": "0a812f72",
      "slug": "farnesina-tor-di-quinto",
      "name": "Farnesina, Tor di Quinto",
      "primary": true,
      "skipSearch": false
    }],
    "camilluccia-cortina-d-ampezzo": [{
      "hkey": "0a812f72",
      "slug": "farnesina-tor-di-quinto",
      "name": "Farnesina, Tor di Quinto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "8a8aa18c": [{
      "hkey": "0a812f72",
      "slug": "farnesina-tor-di-quinto",
      "name": "Farnesina, Tor di Quinto",
      "primary": true,
      "skipSearch": false
    }],
    "corso-francia-ponte-milvio": [{
      "hkey": "0a812f72",
      "slug": "farnesina-tor-di-quinto",
      "name": "Farnesina, Tor di Quinto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "821a2f02": [{
      "hkey": "82a43961",
      "slug": "garbatella-ostiense-ardeatino",
      "name": "Garbatella, Ostiense, Ardeatino",
      "primary": true,
      "skipSearch": false
    }],
    "9dc6a5cc": [{
      "hkey": "d337d956",
      "slug": "ottavia-monte-mario-trionfale",
      "name": "Ottavia, Monte Mario-Trionfale",
      "primary": true,
      "skipSearch": false
    }],
    "ottavia-trionfale-monte-mario": [{
      "hkey": "d337d956",
      "slug": "ottavia-monte-mario-trionfale",
      "name": "Ottavia, Monte Mario-Trionfale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1f5c450c": [{
      "hkey": "f9eea843",
      "slug": "primavalle-battistini-torrevecchia",
      "name": "Primavalle-Battistini, Torrevecchia",
      "primary": true,
      "skipSearch": false
    }],
    "pineta-sacchetti-torrevecchia": [{
      "hkey": "f9eea843",
      "slug": "primavalle-battistini-torrevecchia",
      "name": "Primavalle-Battistini, Torrevecchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "aaeedd22": [{
      "hkey": "a3a5398e",
      "slug": "montespaccato",
      "name": "Montespaccato",
      "primary": true,
      "skipSearch": false
    }],
    "cornelia-montespaccato": [{
      "hkey": "a3a5398e",
      "slug": "montespaccato",
      "name": "Montespaccato",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }],
    "f754874d": [{
      "hkey": "c7353c11",
      "slug": "farnesina-camilluccia",
      "name": "Farnesina-Camilluccia",
      "primary": true,
      "skipSearch": false
    }],
    "camilluccia": [{
      "hkey": "c7353c11",
      "slug": "farnesina-camilluccia",
      "name": "Farnesina-Camilluccia",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": "farnesina-tor-di-quinto"
    }],
    "011c4499": [{
      "hkey": "e44b2dd8",
      "slug": "cortina-d-ampezzo",
      "name": "Cortina d'Ampezzo",
      "primary": true,
      "skipSearch": false
    }],
    "cortina-d-ampezzo": [{
      "hkey": "e44b2dd8",
      "slug": "cortina-d-ampezzo",
      "name": "Cortina d'Ampezzo",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": "farnesina-tor-di-quinto"
    }],
    "a57a14b0": [{
      "hkey": "c7353c11",
      "slug": "farnesina-camilluccia",
      "name": "Farnesina-Camilluccia",
      "primary": true,
      "skipSearch": false
    }],
    "farnesina": [{
      "hkey": "c7353c11",
      "slug": "farnesina-camilluccia",
      "name": "Farnesina-Camilluccia",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }],
    "d80e8c5a": [{
      "hkey": "3ae36431",
      "slug": "ponte-milvio-foro-italico",
      "name": "Ponte Milvio-Foro Italico",
      "primary": true,
      "skipSearch": false
    }],
    "foro-italico": [{
      "hkey": "3ae36431",
      "slug": "ponte-milvio-foro-italico",
      "name": "Ponte Milvio-Foro Italico",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }],
    "fd46b20d": [{
      "hkey": "83618070",
      "slug": "tor-di-quinto-fleming",
      "name": "Tor di Quinto-Fleming",
      "primary": true,
      "skipSearch": false
    }],
    "tor-di-quinto": [{
      "hkey": "83618070",
      "slug": "tor-di-quinto-fleming",
      "name": "Tor di Quinto-Fleming",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }],
    "dc733c53": [{
      "hkey": "bce305ea",
      "slug": "vigna-clara-vigna-stelluti",
      "name": "Vigna Clara-Vigna Stelluti",
      "primary": true,
      "skipSearch": false
    }],
    "vigna-clara-fleming": [{
      "hkey": "bce305ea",
      "slug": "vigna-clara-vigna-stelluti",
      "name": "Vigna Clara-Vigna Stelluti",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }],
    "ad93bcda": [{
      "hkey": "92cb7397",
      "slug": "parioli",
      "name": "Parioli",
      "primary": true,
      "skipSearch": false
    }],
    "villa-ada": [{
      "hkey": "92cb7397",
      "slug": "parioli",
      "name": "Parioli",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": "flaminio-parioli"
    }],
    "f0f9b222": [{
      "hkey": "bd018bf1",
      "slug": "pinciano-villa-borghese",
      "name": "Pinciano-Villa Borghese",
      "primary": true,
      "skipSearch": false
    }],
    "villa-borghese": [{
      "hkey": "bd018bf1",
      "slug": "pinciano-villa-borghese",
      "name": "Pinciano-Villa Borghese",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }],
    "7af579bc": [{
      "hkey": "be2c7042",
      "slug": "spinaceto-tre-pini-tor-de-cenci",
      "name": "Spinaceto-Tre Pini-Tor De' Cenci",
      "primary": true,
      "skipSearch": false
    }],
    "spinaceto": [{
      "hkey": "be2c7042",
      "slug": "spinaceto-tre-pini-tor-de-cenci",
      "name": "Spinaceto-Tre Pini-Tor De' Cenci",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }],
    "70266528": [{
      "hkey": "5838316e",
      "slug": "monte-mario-trionfale",
      "name": "Monte Mario-Trionfale",
      "primary": true,
      "skipSearch": false
    }],
    "trionfale": [{
      "hkey": "5838316e",
      "slug": "monte-mario-trionfale",
      "name": "Monte Mario-Trionfale",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }],
    "1deb3f84": [{
      "hkey": "25c3d721",
      "slug": "primavalle-battistini-gemelli",
      "name": "Primavalle-Battistini-Gemelli",
      "primary": true,
      "skipSearch": false
    }],
    "pineta-sacchetti": [{
      "hkey": "25c3d721",
      "slug": "primavalle-battistini-gemelli",
      "name": "Primavalle-Battistini-Gemelli",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": "primavalle-battistini-torrevecchia"
    }],
    "6ab30722": [{
      "hkey": "25c3d721",
      "slug": "primavalle-battistini-gemelli",
      "name": "Primavalle-Battistini-Gemelli",
      "primary": true,
      "skipSearch": false
    }],
    "primavalle-battistini": [{
      "hkey": "25c3d721",
      "slug": "primavalle-battistini-gemelli",
      "name": "Primavalle-Battistini-Gemelli",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }],
    "cassia-san-godenzo-grottarossa": [{
      "hkey": "2405a57f",
      "slug": "cassia-san-godenzo-due-ponti-grottarossa-tomba-di-nerone",
      "name": "Cassia-San Godenzo, Due Ponti, Grottarossa, Tomba di Nerone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "trigoria-spinaceto-tor-de-cenci-vallerano": [{
      "hkey": "f50be3f0",
      "slug": "castel-porziano-castel-romano-trigoria",
      "name": "Castel Porziano, Castel Romano, Trigoria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "cecchignola-fonte-meravigliosa": [{
      "hkey": "180ecba5",
      "slug": "giuliano-dalmata-fonte-meravigliosa-laurentino",
      "name": "Giuliano Dalmata, Fonte Meravigliosa, Laurentino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "olgiata-giustiniana": [{
      "hkey": "a6eb7666",
      "slug": "cesano-giustiniana-olgiata",
      "name": "Cesano, Giustiniana, Olgiata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "83cb304d": [{
      "hkey": "d337d956",
      "slug": "ottavia-monte-mario-trionfale",
      "name": "Ottavia, Monte Mario-Trionfale",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "3756f4a2",
      "slug": "balduina-eroi-medaglie-d-oro",
      "name": "Balduina, Eroi, Medaglie d'Oro",
      "primary": true,
      "skipSearch": false
    }],
    "trionfale-monte-mario-ottavia": [{
      "hkey": "d337d956",
      "slug": "ottavia-monte-mario-trionfale",
      "name": "Ottavia, Monte Mario-Trionfale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4d9be02e": [{
      "hkey": "46d6b680",
      "slug": "fioranello-aeroporto-ciampino",
      "name": "Fioranello-Aeroporto Ciampino",
      "primary": true,
      "skipSearch": false
    }],
    "ciampino": [{
      "hkey": "46d6b680",
      "slug": "fioranello-aeroporto-ciampino",
      "name": "Fioranello-Aeroporto Ciampino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "castel-di-leva-fonte-laurentina-vallerano"
    }],
    "fc63815e": [{
      "hkey": "46d6b680",
      "slug": "fioranello-aeroporto-ciampino",
      "name": "Fioranello-Aeroporto Ciampino",
      "primary": true,
      "skipSearch": false
    }],
    "fioranello": [{
      "hkey": "46d6b680",
      "slug": "fioranello-aeroporto-ciampino",
      "name": "Fioranello-Aeroporto Ciampino",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }],
    "6c09cd41": [{
      "hkey": "d4c75c69",
      "slug": "torre-angela-tor-bella-monaca",
      "name": "Torre Angela-Tor Bella Monaca",
      "primary": true,
      "skipSearch": false
    }],
    "torre-angela": [{
      "hkey": "d4c75c69",
      "slug": "torre-angela-tor-bella-monaca",
      "name": "Torre Angela-Tor Bella Monaca",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }],
    "0f6946ce": [{
      "hkey": "69e57e7c",
      "slug": "acilia-dragona-malafede-casal-bernocchi-vitinia",
      "name": "Acilia, Dragona, Malafede-Casal Bernocchi, Vitinia",
      "primary": true,
      "skipSearch": false
    }],
    "acilia-vitinia-ostia-antica-malafede-dragona-delle-borgate": [{
      "hkey": "69e57e7c",
      "slug": "acilia-dragona-malafede-casal-bernocchi-vitinia",
      "name": "Acilia, Dragona, Malafede-Casal Bernocchi, Vitinia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "88d6c516": [{
      "hkey": "69e57e7c",
      "slug": "acilia-dragona-malafede-casal-bernocchi-vitinia",
      "name": "Acilia, Dragona, Malafede-Casal Bernocchi, Vitinia",
      "primary": true,
      "skipSearch": false
    }],
    "acilia-casal-bernocchi-centro-giano-dragona-malafede-vitinia": [{
      "hkey": "69e57e7c",
      "slug": "acilia-dragona-malafede-casal-bernocchi-vitinia",
      "name": "Acilia, Dragona, Malafede-Casal Bernocchi, Vitinia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "51858bcf": [{
      "hkey": "4214fc16",
      "slug": "alessandrino-casilina-centocelle",
      "name": "Alessandrino, Casilina, Centocelle",
      "primary": true,
      "skipSearch": false
    }],
    "4e1d05fa": [{
      "hkey": "4214fc16",
      "slug": "alessandrino-casilina-centocelle",
      "name": "Alessandrino, Casilina, Centocelle",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "0f3b7c07",
      "slug": "tor-sapienza-tor-tre-teste-torre-maura",
      "name": "Tor Sapienza, Tor Tre Teste, Torre Maura",
      "primary": true,
      "skipSearch": false
    }],
    "alessandrino-tor-sapienza-torre-maura": [{
      "hkey": "0f3b7c07",
      "slug": "tor-sapienza-tor-tre-teste-torre-maura",
      "name": "Tor Sapienza, Tor Tre Teste, Torre Maura",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "8faac2b7": [{
      "hkey": "c5f6b814",
      "slug": "tor-vergata-romanina-anagnina",
      "name": "Tor Vergata, Romanina, Anagnina",
      "primary": true,
      "skipSearch": false
    }],
    "fc41f313": [{
      "hkey": "c5f6b814",
      "slug": "tor-vergata-romanina-anagnina",
      "name": "Tor Vergata, Romanina, Anagnina",
      "primary": true,
      "skipSearch": false
    }],
    "parco-di-torre-gaia-villa-verde-fontana-candida-papillo": [{
      "hkey": "c5f6b814",
      "slug": "tor-vergata-romanina-anagnina",
      "name": "Tor Vergata, Romanina, Anagnina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "tor-vergata-morena-romanina": [{
      "hkey": "c5f6b814",
      "slug": "tor-vergata-romanina-anagnina",
      "name": "Tor Vergata, Romanina, Anagnina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "a6eff2e9": [{
      "hkey": "c5f6b814",
      "slug": "tor-vergata-romanina-anagnina",
      "name": "Tor Vergata, Romanina, Anagnina",
      "primary": true,
      "skipSearch": false
    }],
    "anagnina-romanina-tor-vergata": [{
      "hkey": "c5f6b814",
      "slug": "tor-vergata-romanina-anagnina",
      "name": "Tor Vergata, Romanina, Anagnina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "8b5d1dd9": [{
      "hkey": "7947a8ef",
      "slug": "appio-pignatelli-quarto-miglio",
      "name": "Appio Pignatelli, Quarto Miglio",
      "primary": true,
      "skipSearch": false
    }],
    "appia-pignatelli-quarto-miglio": [{
      "hkey": "7947a8ef",
      "slug": "appio-pignatelli-quarto-miglio",
      "name": "Appio Pignatelli, Quarto Miglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "5ede6855": [{
      "hkey": "82a43961",
      "slug": "garbatella-ostiense-ardeatino",
      "name": "Garbatella, Ostiense, Ardeatino",
      "primary": true,
      "skipSearch": false
    }],
    "ardeatino-montagnola": [{
      "hkey": "82a43961",
      "slug": "garbatella-ostiense-ardeatino",
      "name": "Garbatella, Ostiense, Ardeatino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "01040ed7": [{
      "hkey": "79385c01",
      "slug": "aurelio-val-cannuta-boccea",
      "name": "Aurelio-Val Cannuta, Boccea",
      "primary": false,
      "skipSearch": false
    }],
    "0bb16c88": [{
      "hkey": "79385c01",
      "slug": "aurelio-val-cannuta-boccea",
      "name": "Aurelio-Val Cannuta, Boccea",
      "primary": true,
      "skipSearch": false
    }],
    "aurelio-boccea": [{
      "hkey": "79385c01",
      "slug": "aurelio-val-cannuta-boccea",
      "name": "Aurelio-Val Cannuta, Boccea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "98013cc9": [{
      "hkey": "adc31a71",
      "slug": "aventino-caracalla-san-saba",
      "name": "Aventino, Caracalla, San Saba",
      "primary": true,
      "skipSearch": false
    }],
    "aventino-san-saba-caracalla": [{
      "hkey": "adc31a71",
      "slug": "aventino-caracalla-san-saba",
      "name": "Aventino, Caracalla, San Saba",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "b59259a1": [{
      "hkey": "69e57e7c",
      "slug": "acilia-dragona-malafede-casal-bernocchi-vitinia",
      "name": "Acilia, Dragona, Malafede-Casal Bernocchi, Vitinia",
      "primary": true,
      "skipSearch": false
    }],
    "520a4d35": [{
      "hkey": "69e57e7c",
      "slug": "acilia-dragona-malafede-casal-bernocchi-vitinia",
      "name": "Acilia, Dragona, Malafede-Casal Bernocchi, Vitinia",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "aa8abe6c",
      "slug": "axa-infernetto-palocco",
      "name": "Axa, Infernetto, Palocco",
      "primary": true,
      "skipSearch": false
    }],
    "infernetto-axa-casal-palocco-madonnetta-a-roma": [{
      "hkey": "aa8abe6c",
      "slug": "axa-infernetto-palocco",
      "name": "Axa, Infernetto, Palocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "axa-casal-palocco-infernetto": [{
      "hkey": "aa8abe6c",
      "slug": "axa-infernetto-palocco",
      "name": "Axa, Infernetto, Palocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "balduina-trionfale-montemario": [{
      "hkey": "3756f4a2",
      "slug": "balduina-eroi-medaglie-d-oro",
      "name": "Balduina, Eroi, Medaglie d'Oro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "c3c0b168": [{
      "hkey": "3756f4a2",
      "slug": "balduina-eroi-medaglie-d-oro",
      "name": "Balduina, Eroi, Medaglie d'Oro",
      "primary": true,
      "skipSearch": false
    }],
    "balduina-medaglie-d-oro-degli-eroi": [{
      "hkey": "3756f4a2",
      "slug": "balduina-eroi-medaglie-d-oro",
      "name": "Balduina, Eroi, Medaglie d'Oro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "ea4f3a99": [{
      "hkey": "79385c01",
      "slug": "aurelio-val-cannuta-boccea",
      "name": "Aurelio-Val Cannuta, Boccea",
      "primary": true,
      "skipSearch": false
    }],
    "021e5230": [{
      "hkey": "79385c01",
      "slug": "aurelio-val-cannuta-boccea",
      "name": "Aurelio-Val Cannuta, Boccea",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "f9eea843",
      "slug": "primavalle-battistini-torrevecchia",
      "name": "Primavalle-Battistini, Torrevecchia",
      "primary": true,
      "skipSearch": false
    }],
    "boccea-torrevecchia-pineta-sacchetti-selva-candida-ottavia": [{
      "hkey": "f9eea843",
      "slug": "primavalle-battistini-torrevecchia",
      "name": "Primavalle-Battistini, Torrevecchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "battistini-torrevecchia": [{
      "hkey": "f9eea843",
      "slug": "primavalle-battistini-torrevecchia",
      "name": "Primavalle-Battistini, Torrevecchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6acb3b44": [{
      "hkey": "40677f98",
      "slug": "nomentano-piazza-bologna-policlinico",
      "name": "Nomentano, Piazza Bologna, Policlinico",
      "primary": true,
      "skipSearch": false
    }],
    "bologna-nomentano": [{
      "hkey": "40677f98",
      "slug": "nomentano-piazza-bologna-policlinico",
      "name": "Nomentano, Piazza Bologna, Policlinico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "cdffc59f": [{
      "hkey": "40677f98",
      "slug": "nomentano-piazza-bologna-policlinico",
      "name": "Nomentano, Piazza Bologna, Policlinico",
      "primary": true,
      "skipSearch": false
    }],
    "bologna-policlinico": [{
      "hkey": "40677f98",
      "slug": "nomentano-piazza-bologna-policlinico",
      "name": "Nomentano, Piazza Bologna, Policlinico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "1991b747": [{
      "hkey": "42ecf1fb",
      "slug": "bufalotta-porta-di-roma-settebagni",
      "name": "Bufalotta, Porta di Roma, Settebagni",
      "primary": true,
      "skipSearch": false
    }],
    "be3e6376": [{
      "hkey": "42ecf1fb",
      "slug": "bufalotta-porta-di-roma-settebagni",
      "name": "Bufalotta, Porta di Roma, Settebagni",
      "primary": true,
      "skipSearch": false
    }],
    "54c95aff": [{
      "hkey": "42ecf1fb",
      "slug": "bufalotta-porta-di-roma-settebagni",
      "name": "Bufalotta, Porta di Roma, Settebagni",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "5248daea",
      "slug": "casal-monastero-sant-alessandro-settecamini",
      "name": "Casal Monastero-Sant'Alessandro, Settecamini",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "b3d0d04e",
      "slug": "tor-san-giovanni-marcigliana",
      "name": "Tor San Giovanni, Marcigliana",
      "primary": false,
      "skipSearch": false
    }],
    "settebagni-salaria": [{
      "hkey": "5248daea",
      "slug": "casal-monastero-sant-alessandro-settecamini",
      "name": "Casal Monastero-Sant'Alessandro, Settecamini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "settecamini": [{
      "hkey": "5248daea",
      "slug": "casal-monastero-sant-alessandro-settecamini",
      "name": "Casal Monastero-Sant'Alessandro, Settecamini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "bufalotta-casal-monastero-settebagni": [{
      "hkey": "5248daea",
      "slug": "casal-monastero-sant-alessandro-settecamini",
      "name": "Casal Monastero-Sant'Alessandro, Settecamini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "dba5b97a": [{
      "hkey": "79385c01",
      "slug": "aurelio-val-cannuta-boccea",
      "name": "Aurelio-Val Cannuta, Boccea",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "c162ec31",
      "slug": "casal-selce-casalotti-selva-candida-selva-nera",
      "name": "Casal Selce, Casalotti, Selva Candida, Selva Nera",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "008a029a",
      "slug": "castel-di-guido-valle-santa",
      "name": "Castel di Guido, Valle Santa",
      "primary": false,
      "skipSearch": false
    }],
    "casalotti-montespaccato-maglianella-casal-selce-selva-candida-selva-nera": [{
      "hkey": "c162ec31",
      "slug": "casal-selce-casalotti-selva-candida-selva-nera",
      "name": "Casal Selce, Casalotti, Selva Candida, Selva Nera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "b8baad0e": [{
      "hkey": "4214fc16",
      "slug": "alessandrino-casilina-centocelle",
      "name": "Alessandrino, Casilina, Centocelle",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "d963eee8",
      "slug": "casal-bertone-pigneto",
      "name": "Casal Bertone, Pigneto",
      "primary": false,
      "skipSearch": false
    }],
    "centocelle-tor-de-schiavi": [{
      "hkey": "4214fc16",
      "slug": "alessandrino-casilina-centocelle",
      "name": "Alessandrino, Casilina, Centocelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "27a82925": [{
      "hkey": "94336790",
      "slug": "capannelle-cinecitta-quadraro",
      "name": "Capannelle, Cinecittà, Quadraro",
      "primary": true,
      "skipSearch": false
    }],
    "tuscolano-don-bosco-cinecitta": [{
      "hkey": "94336790",
      "slug": "capannelle-cinecitta-quadraro",
      "name": "Capannelle, Cinecittà, Quadraro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "8277957f": [{
      "hkey": "94336790",
      "slug": "capannelle-cinecitta-quadraro",
      "name": "Capannelle, Cinecittà, Quadraro",
      "primary": true,
      "skipSearch": false
    }],
    "cinecitta-quadraro": [{
      "hkey": "94336790",
      "slug": "capannelle-cinecitta-quadraro",
      "name": "Capannelle, Cinecittà, Quadraro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "83468471": [{
      "hkey": "e3a173bf",
      "slug": "tuscolana-colli-albani",
      "name": "Tuscolana, Colli Albani",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "5e6a1478",
      "slug": "appio-latino-re-di-roma-san-giovanni",
      "name": "Appio Latino, Re di Roma, San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "435ecf16": [{
      "hkey": "e3a173bf",
      "slug": "tuscolana-colli-albani",
      "name": "Tuscolana, Colli Albani",
      "primary": true,
      "skipSearch": false
    }],
    "colli-albani-tuscolana": [{
      "hkey": "e3a173bf",
      "slug": "tuscolana-colli-albani",
      "name": "Tuscolana, Colli Albani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "543a5fff": [{
      "hkey": "73e873f6",
      "slug": "colli-portuensi-gianicolense-monteverde",
      "name": "Colli Portuensi, Gianicolense, Monteverde",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "acd9c38f",
      "slug": "magliana-trullo",
      "name": "Magliana, Trullo",
      "primary": true,
      "skipSearch": false
    }],
    "d2c41867": [{
      "hkey": "73e873f6",
      "slug": "colli-portuensi-gianicolense-monteverde",
      "name": "Colli Portuensi, Gianicolense, Monteverde",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "44fc4416",
      "slug": "marconi-portuense-san-paolo",
      "name": "Marconi, Portuense, San Paolo",
      "primary": false,
      "skipSearch": false
    }],
    "colli-portuensi-casaletto-villa-bonelli": [{
      "hkey": "73e873f6",
      "slug": "colli-portuensi-gianicolense-monteverde",
      "name": "Colli Portuensi, Gianicolense, Monteverde",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "6315bef3": [{
      "hkey": "0a812f72",
      "slug": "farnesina-tor-di-quinto",
      "name": "Farnesina, Tor di Quinto",
      "primary": true,
      "skipSearch": false
    }],
    "corso-francia-vigna-clara-fleming-ponte-milvio": [{
      "hkey": "0a812f72",
      "slug": "farnesina-tor-di-quinto",
      "name": "Farnesina, Tor di Quinto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d40b1bd3": [{
      "hkey": "937ded5a",
      "slug": "eur-tintoretto-torrino",
      "name": "Eur, Tintoretto, Torrino",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "69c88fc3",
      "slug": "mezzocammino-spinaceto",
      "name": "Mezzocammino, Spinaceto",
      "primary": false,
      "skipSearch": false
    }],
    "eur-laurentino-cecchignola-montagnola-fonte-meravigliosa": [{
      "hkey": "937ded5a",
      "slug": "eur-tintoretto-torrino",
      "name": "Eur, Tintoretto, Torrino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "torrino-mostacciano": [{
      "hkey": "937ded5a",
      "slug": "eur-tintoretto-torrino",
      "name": "Eur, Tintoretto, Torrino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "360a504c": [{
      "hkey": "937ded5a",
      "slug": "eur-tintoretto-torrino",
      "name": "Eur, Tintoretto, Torrino",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "180ecba5",
      "slug": "giuliano-dalmata-fonte-meravigliosa-laurentino",
      "name": "Giuliano Dalmata, Fonte Meravigliosa, Laurentino",
      "primary": false,
      "skipSearch": false
    }],
    "eur-torrino-tintoretto": [{
      "hkey": "937ded5a",
      "slug": "eur-tintoretto-torrino",
      "name": "Eur, Tintoretto, Torrino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "0a32ab9c": [{
      "hkey": "82a43961",
      "slug": "garbatella-ostiense-ardeatino",
      "name": "Garbatella, Ostiense, Ardeatino",
      "primary": true,
      "skipSearch": false
    }],
    "ardeatino-colombo-garbatella": [{
      "hkey": "82a43961",
      "slug": "garbatella-ostiense-ardeatino",
      "name": "Garbatella, Ostiense, Ardeatino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "e5bc940e": [{
      "hkey": "82a43961",
      "slug": "garbatella-ostiense-ardeatino",
      "name": "Garbatella, Ostiense, Ardeatino",
      "primary": true,
      "skipSearch": false
    }],
    "garbatella-navigatori-ostiense": [{
      "hkey": "82a43961",
      "slug": "garbatella-ostiense-ardeatino",
      "name": "Garbatella, Ostiense, Ardeatino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "portuense-magliana": [{
      "hkey": "acd9c38f",
      "slug": "magliana-trullo",
      "name": "Magliana, Trullo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "c72ab1c2": [{
      "hkey": "acd9c38f",
      "slug": "magliana-trullo",
      "name": "Magliana, Trullo",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "44fc4416",
      "slug": "marconi-portuense-san-paolo",
      "name": "Marconi, Portuense, San Paolo",
      "primary": false,
      "skipSearch": false
    }],
    "magliana-trullo-parco-de-medici": [{
      "hkey": "acd9c38f",
      "slug": "magliana-trullo",
      "name": "Magliana, Trullo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "3f142866": [{
      "hkey": "82a43961",
      "slug": "garbatella-ostiense-ardeatino",
      "name": "Garbatella, Ostiense, Ardeatino",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "44fc4416",
      "slug": "marconi-portuense-san-paolo",
      "name": "Marconi, Portuense, San Paolo",
      "primary": true,
      "skipSearch": false
    }],
    "marconi-ostiense-san-paolo": [{
      "hkey": "44fc4416",
      "slug": "marconi-portuense-san-paolo",
      "name": "Marconi, Portuense, San Paolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "marconi-san-paolo": [{
      "hkey": "44fc4416",
      "slug": "marconi-portuense-san-paolo",
      "name": "Marconi, Portuense, San Paolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "af9ed8d7": [{
      "hkey": "69c88fc3",
      "slug": "mezzocammino-spinaceto",
      "name": "Mezzocammino, Spinaceto",
      "primary": true,
      "skipSearch": false
    }],
    "mezzocammino-spinaceto-tor-de-cenci": [{
      "hkey": "69c88fc3",
      "slug": "mezzocammino-spinaceto",
      "name": "Mezzocammino, Spinaceto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "parioli-pinciano": [{
      "hkey": "1d01e051",
      "slug": "flaminio-parioli",
      "name": "Flaminio, Parioli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "d6a6581f": [{
      "hkey": "1d01e051",
      "slug": "flaminio-parioli",
      "name": "Flaminio, Parioli",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "2eccd6ef",
      "slug": "salario-trieste-africano",
      "name": "Salario, Trieste-Africano",
      "primary": false,
      "skipSearch": false
    }],
    "parioli-flaminio": [{
      "hkey": "1d01e051",
      "slug": "flaminio-parioli",
      "name": "Flaminio, Parioli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "ed8f85d1": [{
      "hkey": "d963eee8",
      "slug": "casal-bertone-pigneto",
      "name": "Casal Bertone, Pigneto",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "f1362495",
      "slug": "san-lorenzo-universita-sapienza",
      "name": "San Lorenzo, Università Sapienza",
      "primary": false,
      "skipSearch": false
    }],
    "pigneto-san-lorenzo-casal-bertone": [{
      "hkey": "d963eee8",
      "slug": "casal-bertone-pigneto",
      "name": "Casal Bertone, Pigneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "7b3370f5": [{
      "hkey": "dda4cb97",
      "slug": "casal-de-pazzi-tor-cervara",
      "name": "Casal de' Pazzi, Tor Cervara",
      "primary": true,
      "skipSearch": false
    }],
    "san-basilio-ponte-mammolo": [{
      "hkey": "dda4cb97",
      "slug": "casal-de-pazzi-tor-cervara",
      "name": "Casal de' Pazzi, Tor Cervara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "0f181d0b": [{
      "hkey": "dda4cb97",
      "slug": "casal-de-pazzi-tor-cervara",
      "name": "Casal de' Pazzi, Tor Cervara",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "e3ea8ea7",
      "slug": "san-basilio",
      "name": "San Basilio",
      "primary": false,
      "skipSearch": false
    }],
    "ponte-mammolo-san-basilio-tor-cervara": [{
      "hkey": "dda4cb97",
      "slug": "casal-de-pazzi-tor-cervara",
      "name": "Casal de' Pazzi, Tor Cervara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "e1857448": [{
      "hkey": "42ecf1fb",
      "slug": "bufalotta-porta-di-roma-settebagni",
      "name": "Bufalotta, Porta di Roma, Settebagni",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "b618ce04",
      "slug": "conca-d-oro-monte-sacro-talenti",
      "name": "Conca d'Oro, Monte Sacro, Talenti",
      "primary": true,
      "skipSearch": false
    }],
    "17f35c44": [{
      "hkey": "42ecf1fb",
      "slug": "bufalotta-porta-di-roma-settebagni",
      "name": "Bufalotta, Porta di Roma, Settebagni",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "84cfd4d8",
      "slug": "casal-boccone",
      "name": "Casal Boccone",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "d8c6535f",
      "slug": "fidene-serpentara-tufello",
      "name": "Fidene, Serpentara, Tufello",
      "primary": false,
      "skipSearch": false
    }],
    "porta-di-roma-casal-boccone": [{
      "hkey": "42ecf1fb",
      "slug": "bufalotta-porta-di-roma-settebagni",
      "name": "Bufalotta, Porta di Roma, Settebagni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "d1059e32": [{
      "hkey": "3756f4a2",
      "slug": "balduina-eroi-medaglie-d-oro",
      "name": "Balduina, Eroi, Medaglie d'Oro",
      "primary": true,
      "skipSearch": false
    }],
    "7fe1f2a8": [{
      "hkey": "3756f4a2",
      "slug": "balduina-eroi-medaglie-d-oro",
      "name": "Balduina, Eroi, Medaglie d'Oro",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "f4ecf6ca",
      "slug": "borgo-mazzini-delle-vittorie-prati",
      "name": "Borgo, Mazzini-Delle Vittorie, Prati",
      "primary": true,
      "skipSearch": false
    }],
    "prati-delle-vittorie-borgo-pio": [{
      "hkey": "f4ecf6ca",
      "slug": "borgo-mazzini-delle-vittorie-prati",
      "name": "Borgo, Mazzini-Delle Vittorie, Prati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "prati-borgo-mazzini-delle-vittorie": [{
      "hkey": "f4ecf6ca",
      "slug": "borgo-mazzini-delle-vittorie-prati",
      "name": "Borgo, Mazzini-Delle Vittorie, Prati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "24012704": [{
      "hkey": "5e6a1478",
      "slug": "appio-latino-re-di-roma-san-giovanni",
      "name": "Appio Latino, Re di Roma, San Giovanni",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "cace34c7",
      "slug": "repubblica-termini",
      "name": "Repubblica, Termini",
      "primary": true,
      "skipSearch": false
    }],
    "appio-latino-appia-nuova-appio-pignatelli-capannelle": [{
      "hkey": "5e6a1478",
      "slug": "appio-latino-re-di-roma-san-giovanni",
      "name": "Appio Latino, Re di Roma, San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "5c06f6b8": [{
      "hkey": "5e6a1478",
      "slug": "appio-latino-re-di-roma-san-giovanni",
      "name": "Appio Latino, Re di Roma, San Giovanni",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "e3a173bf",
      "slug": "tuscolana-colli-albani",
      "name": "Tuscolana, Colli Albani",
      "primary": false,
      "skipSearch": false
    }],
    "re-di-roma-san-giovanni": [{
      "hkey": "5e6a1478",
      "slug": "appio-latino-re-di-roma-san-giovanni",
      "name": "Appio Latino, Re di Roma, San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "247a2b4a": [{
      "hkey": "2eccd6ef",
      "slug": "salario-trieste-africano",
      "name": "Salario, Trieste-Africano",
      "primary": true,
      "skipSearch": false
    }],
    "trieste-salario": [{
      "hkey": "2eccd6ef",
      "slug": "salario-trieste-africano",
      "name": "Salario, Trieste-Africano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "d919047c": [{
      "hkey": "2eccd6ef",
      "slug": "salario-trieste-africano",
      "name": "Salario, Trieste-Africano",
      "primary": true,
      "skipSearch": false
    }],
    "salario-trieste": [{
      "hkey": "2eccd6ef",
      "slug": "salario-trieste-africano",
      "name": "Salario, Trieste-Africano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "nuovo-salario-prati-fiscali-monte-sacro-talenti-vigne-nuove": [{
      "hkey": "b618ce04",
      "slug": "conca-d-oro-monte-sacro-talenti",
      "name": "Conca d'Oro, Monte Sacro, Talenti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "270b3d80": [{
      "hkey": "b618ce04",
      "slug": "conca-d-oro-monte-sacro-talenti",
      "name": "Conca d'Oro, Monte Sacro, Talenti",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "d8c6535f",
      "slug": "fidene-serpentara-tufello",
      "name": "Fidene, Serpentara, Tufello",
      "primary": false,
      "skipSearch": false
    }],
    "talenti-monte-sacro-conca-d-oro": [{
      "hkey": "b618ce04",
      "slug": "conca-d-oro-monte-sacro-talenti",
      "name": "Conca d'Oro, Monte Sacro, Talenti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "s-giovanni-esquilino-san-lorenzo": [{
      "hkey": "cace34c7",
      "slug": "repubblica-termini",
      "name": "Repubblica, Termini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }],
    "311b5b74": [{
      "hkey": "cace34c7",
      "slug": "repubblica-termini",
      "name": "Repubblica, Termini",
      "primary": true,
      "skipSearch": false
    }],
    "termini-repubblica": [{
      "hkey": "cace34c7",
      "slug": "repubblica-termini",
      "name": "Repubblica, Termini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roma"
    }]
  }
};
exports["default"] = _default;